// extracted by mini-css-extract-plugin
export default {"root":"KQPvRt","feedSide":"UyR1H4","feed":"EMgrwP","reviewsFilter":"qg4h6_"};